import { ref, onMounted, onBeforeUnmount } from "vue";
import { unrefElement } from "./unrefElement.es.js";
function useClickOutside(target, handler, useMountedHooks = true) {
  const handleClick = (event) => {
    const el = unrefElement(target);
    if (!el || el === event.target || event.composedPath().includes(el))
      return;
    handler(event);
  };
  let started = ref(false);
  const start = () => {
    if (started.value)
      return;
    document.addEventListener("click", handleClick, { passive: true, capture: true });
    started.value = true;
  };
  const stop = () => {
    if (!started.value)
      return;
    document.removeEventListener("click", handleClick, { capture: true });
    started.value = false;
  };
  if (useMountedHooks) {
    onMounted(start);
    onBeforeUnmount(stop);
  }
  return {
    start,
    stop
  };
}
export {
  useClickOutside
};
//# sourceMappingURL=useClickOutside.es.js.map
